// This file is auto-generated by @hey-api/openapi-ts
import { createClient, createConfig } from './client';
export const client = createClient(createConfig({
    baseUrl: 'https://api.column.com/',
}));
//# sourceMappingURL=client.gen.js.map